import axios from 'axios';
import { handleError } from '@/shared/services/api';

export default {
  baseUrl(id) {
    let url = `${window.api_url}/v2/cohort_members`;
    if (id) url += `/${id}`;
    return url;
  },

  index(filters) {
    return axios.get(this.baseUrl(), { params: filters }).catch(handleError);
  },

  create(cohortMember) {
    return axios.post(this.baseUrl(), cohortMember).catch(handleError);
  },
};
